import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { AppContext } from '@/contexts/AppContext/AppContextProvider.tsx';

export const ReportsRoutes = () => {
	const { admin, isReportsAvailable } = useContext(AppContext);

	if (!admin && !isReportsAvailable) {
		return <Navigate to={'/'} replace />;
	}

	return <Outlet />;
};
